import React from 'react';
import {
  SERVICE_CALENDAR_COLOR_PRESETS,
  labelStyleFromCalendarColor,
  normalizeCalendarColor,
} from './serviceCalendarColor';
import './ServiceCalendarColorField.css';

export default function ServiceCalendarColorField({ value, onChange, disabled = false }) {
  const selected = normalizeCalendarColor(value);
  const customValue = selected || '#90CAF9';

  return (
    <div className="svc-cal-color">
      <div className="svc-cal-color__label">Calendar color</div>
      <div className="svc-cal-color__hint">
        Optional. Colors appointment labels in the team calendar for this service.
      </div>

      <div className="svc-cal-color__row" role="group" aria-label="Calendar color">
        <button
          type="button"
          className={`svc-cal-color__auto${!selected ? ' svc-cal-color__auto--active' : ''}`}
          onClick={() => onChange?.(null)}
          disabled={disabled}
          aria-pressed={!selected}
        >
          Auto
        </button>

        {SERVICE_CALENDAR_COLOR_PRESETS.map((hex) => {
          const isActive = selected === hex;
          return (
            <button
              key={hex}
              type="button"
              className={`svc-cal-color__swatch${isActive ? ' svc-cal-color__swatch--active' : ''}`}
              style={{ '--swatch-color': hex }}
              onClick={() => onChange?.(hex)}
              disabled={disabled}
              aria-label={`Color ${hex}`}
              aria-pressed={isActive}
            />
          );
        })}

        <label className="svc-cal-color__custom">
          <input
            type="color"
            value={customValue}
            onChange={(e) => onChange?.(normalizeCalendarColor(e.target.value))}
            disabled={disabled}
            aria-label="Custom calendar color"
          />
          <span>Custom</span>
        </label>
      </div>

      {selected ? (
        <div
          className="svc-cal-color__preview"
          style={labelStyleFromCalendarColor(selected)}
          aria-hidden
        >
          <span className="svc-cal-color__preview-accent" />
          <span className="svc-cal-color__preview-body">Preview</span>
        </div>
      ) : null}
    </div>
  );
}
